import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { RURAL_OVI_PORTAL_KEY } from 'src/app/core/types/projeto.types';

@Injectable({ providedIn: 'root' })
export class RuralOviAuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    if (route.paramMap.get('mode') !== RURAL_OVI_PORTAL_KEY) {
      return true;
    }

    if (this.hasAuthenticatedUser()) {
      return true;
    }

    return this.router.createUrlTree(['/auth/login'], {
      queryParams: { redirect: state.url },
    });
  }

  private hasAuthenticatedUser(): boolean {
    try {
      const currentUser = JSON.parse(localStorage.getItem('currentUser') || '');
      return (
        !!currentUser &&
        typeof currentUser.authToken === 'string' &&
        typeof currentUser.tnToken === 'string'
      );
    } catch {
      return false;
    }
  }
}
